import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import axios from 'axios';
import '../pages/AuthPages.css';

const ResetPassword = () => {
  const [password, setPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const { token } = useParams();
  const navigate = useNavigate();

  useEffect(() => {
    if (!message) return undefined;
    const timer = setTimeout(() => navigate('/login'), 3000);
    return () => clearTimeout(timer);
  }, [message, navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setMessage('');
    if (password !== confirmPassword) {
      setError('Passwords do not match');
      return;
    }
    if (password.length < 6) {
      setError('Password must be at least 6 characters');
      return;
    }
    try {
      setLoading(true);
      const response = await axios.post(`/api/auth/reset-password/${token}`, { password });
      setMessage(response.data.message || 'Password reset successful');
    } catch (err) {
      setError(err.response?.data?.message || 'An error occurred');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth">
      <section className="cr-card auth-card">
        <h1>Set New Password</h1>
        {message && <p className="auth-msg success" role="status">{message}</p>}
        {error && <p className="auth-msg error" role="alert">{error}</p>}

        <form onSubmit={handleSubmit} className="auth-form" noValidate>
          <div className="auth-field">
            <label htmlFor="password">New Password</label>
            <input
              type="password"
              id="password"
              className="cr-input"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              autoComplete="new-password"
            />
          </div>
          <div className="auth-field">
            <label htmlFor="confirmPassword">Confirm Password</label>
            <input
              type="password"
              id="confirmPassword"
              className="cr-input"
              value={confirmPassword}
              onChange={(e) => setConfirmPassword(e.target.value)}
              autoComplete="new-password"
            />
          </div>
          <button type="submit" className="cr-btn solid auth-btn" disabled={loading}>
            {loading ? 'Resetting' : 'Reset Password'}
          </button>
        </form>

        <div className="auth-links">
          <p><Link to="/login">Back to Login</Link></p>
        </div>
      </section>
    </div>
  );
};

export default ResetPassword;
